{
  "partner": {
    "common": {
      "refresh": "Refresh",
      "loadError": "Could not load the data.",
      "retry": "Try again",
      "adminOnlyTitle": "Partner admins only"
    },
    "settings": {
      "adminOnlyDescription": "Settings are reserved for partner admins.",
      "tabs": {
        "users": "User Management"
      }
    },
    "team": {
      "inviteSuccess": "Invitation sent",
      "inviteError": "Could not send the invitation.",
      "activateSales": {
        "action": "Activate for Sales",
        "successCreated": "HubSpot contact created and linked – the user can now submit leads.",
        "successLinked": "Linked to the HubSpot contact – the user can now submit leads.",
        "error": "Sales activation failed (missing HubSpot write scope?)."
      },
      "adminOnlyDescription": "User management is reserved for partner admins.",
      "membersTitle": "Bliks users",
      "membersEmpty": "No users yet.",
      "columns": {
        "name": "Name",
        "email": "Email",
        "role": "Role",
        "status": "Status",
        "position": "Position",
        "salesStatus": "Sales status"
      },
      "salesStatus": {
        "active": "Active for sales",
        "inactive": "Not activated"
      },
      "addMember": "Add member",
      "dialog": {
        "createTitle": "Invite member",
        "editTitle": "Edit member",
        "description": "The team member's name, email and role.",
        "submitCreate": "Invite"
      },
      "createSuccess": "Invitation sent",
      "createError": "Could not create the member.",
      "updateSuccess": "Changes saved",
      "updateError": "Could not save the changes.",
      "suspendSuccess": "Member suspended",
      "unsuspendSuccess": "Member reactivated",
      "deleteSuccess": "Member removed",
      "deleteTitle": "Remove member",
      "deleteDescription": "This member will be permanently removed from the partner account."
    },
    "home": {
      "title": "Home",
      "greeting": "Welcome back, {{name}}",
      "greetingAnonymous": "Welcome back",
      "subtitle": "News from BLIKS IO and everything you need for your sales.",
      "quickLinks": "Quick access",
      "links": {
        "sales": {
          "title": "Sales",
          "description": "Leads, call list and pipeline in the sales app."
        },
        "infoHub": {
          "title": "Info Hub",
          "description": "Documents and videos for your conversations."
        }
      },
      "news": {
        "title": "News",
        "empty": "There is no news right now.",
        "error": "The news could not be loaded.",
        "pinned": "Pinned",
        "storyLabel": "Carousel",
        "goTo": "News {{index}} of {{count}}"
      },
      "recentMaterial": {
        "title": "New in the Info Hub",
        "all": "All documents"
      }
    },
    "infoHub": {
      "title": "Info Hub",
      "subtitle": "Documents and videos from BLIKS IO for your sales.",
      "language": "Language",
      "searchLanguage": "Search language …",
      "noLanguage": "No language found.",
      "search": "Search documents …",
      "category": "Category",
      "categories": {
        "salesDocuments": "Sales documents",
        "presentations": "Presentations",
        "caseStudies": "Case studies",
        "productInfo": "Product information"
      },
      "tabs": {
        "files": "Files ({{count}})",
        "videos": "Videos ({{count}})"
      },
      "columns": {
        "title": "Document",
        "languages": "Languages",
        "format": "Format"
      },
      "new": "New",
      "download": "Download",
      "downloadTitle": "Download “{{title}}” in {{language}}",
      "otherLanguages": "Download “{{title}}” in another language",
      "downloadIn": "Download in",
      "downloadFailed": "The download could not be started.",
      "fallbackHint": "Not available in {{wanted}}; you get the {{language}} version.",
      "playVideo": "Play video “{{title}}”",
      "empty": "No documents yet.",
      "noVideos": "No videos yet.",
      "errorTitle": "Info Hub unavailable",
      "errorDescription": "The documents could not be loaded.",
      "availableIn": "Available in {{languages}}",
      "moreLanguages": "+{{count}}"
    },
    "tasks": {
      "title": "Tasks",
      "subtitle": "What has been handed to you and is still open"
    }
  }
}
